import { api } from '@/scripts/api';

export const DomainService = {

    post(payload) {
        return new Promise((resolve, reject) => {

            const service = '/api/Domains';

            api.post(service, payload)
                .then(resolve)
                .catch(reject);

        });
    },

    get(id, config = {}) {
        return new Promise((resolve, reject) => {

            const service = '/service/Domains';

            const endpoint = api.applyODataParams(service, {
                filter: `Id eq ${id}`,
                ...config
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);

        });
    },

    getAll(config = {}) {
        return new Promise((resolve, reject) => {

            const service = '/service/Domains';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);

        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {

            const service = `/api/Domains/${ id }`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);

        });

    },

    validate(id) {
        return new Promise((resolve, reject) => {

            const service =  `/api/DomainValidation/${ id }`;

            api.put(service)
                .then(resolve)
                .catch(reject)

        });
    },

}
